import ReactOnRails from "react-on-rails";
import Ambassador from "../src/features/sections/ambassador/Ambassador";

ReactOnRails.register({ Ambassador });
